import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject, throwError } from 'rxjs';
import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import {
  CodeConversionMstService
} from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgkd016aResponseOutputinfo, Sgkd043aResponseSosikiInfo } from 'sg-api';
import { UsedSzza012aService } from '../../../../../sg-kd-shared/services/used-szza012a.service';
import { Router } from '@angular/router';
import { UsedSgkd004dSgkd016aService } from '../../services/used-sgkd004d-sgkd016a.service';
import { UsedSgkd004dSgkd043aService } from '../../services/used-sgkd004d-sgkd043a.service';

@Component({
  selector: 'app-sgkd004d-search-condition',
  templateUrl: './sgkd004d-search-condition.component.html',
  styleUrl: './sgkd004d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkd004dSearchConditionComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 検索条件フォーム */
  conditionForm: UntypedFormGroup;

  /** レスポンスエミッター */
  @Output() responseEmitter = new EventEmitter<any>();
  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();

  /** 受付拠点（会社）リスト */
  companyCodeList: SelectBox[] = [];
  /** 受付拠点（組織）リスト */
  repbaseList: SelectBox[] = [];
  /** 全受付拠点（組織）リスト */
  allRepbaseList: Array<Sgkd043aResponseSosikiInfo> = [];
  /** 申込書種別リスト */
  srndocClsfyCodeList: SelectBox[] = [];
  /** 受付日(From)開始日付 */
  aceptDateFromStDate: Date;
  /** 受付日(To)開始日付 */
  aceptDateToStDate: Date;
  /** 申込書送付ステータスリスト */
  srndocDeliveryStatuscodeList: SelectBox[] = [];
  /** 初期化フラグ_コード読込 */
  loadedCodeList: boolean = false;

  /** 業務日付 */
  businessDate: string;
  /** 業務日付 */
  dateBusinessDate: Date;

  /** 検索結果 */
  resultList: Array<Sgkd016aResponseOutputinfo> = [];

  constructor(
    private router: Router,
    private parent: FormGroupDirective,
    private formBuilder: UntypedFormBuilder,
    private usedSzza012aService: UsedSzza012aService,
    private usedSgkd004dSgkd016aService: UsedSgkd004dSgkd016aService,
    private usedSgkd004dSgkd043aService: UsedSgkd004dSgkd043aService,
    private codeConversionMstService: CodeConversionMstService,
    private timeApiService: TimeApiService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd004dSearchConditionComponent
   */
  ngOnInit(): void {
    this.mainForm = this.parent.form;
    this.conditionForm = this.createForm();
    this.mainForm.addControl('conditionForm', this.conditionForm);
    // 業務日付取得
    this.usedSzza012aService.doSzza012a()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.businessDate = response.todayDay;
        this.dateBusinessDate = this.timeApiService.convertStringToDate(this.businessDate);
        this.conditionForm.get('aceptDateTo').setValue(this.dateBusinessDate);
        this.aceptDateFromStDate = this.dateBusinessDate;
        this.aceptDateToStDate = this.dateBusinessDate;
      }, error => {
      });
    // コード値読込
    this.loadCodeList();
    // 組織情報取得
    this.usedSgkd004dSgkd043aService.getSosikiInfo()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.allRepbaseList = response.responseDto.sosikiInfoList;
        this.filteredRepbaseList(this.conditionForm.get('acceptbaseCompany').value);
      }, error => {
      });
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd004dSearchConditionComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    if (this.mainForm) {
      this.mainForm.clearValidators();
      this.mainForm.updateValueAndValidity();
      this.mainForm.removeControl('conditionForm');
    }
  }

  /**
   * 受付拠点（会社）変更
   * 
   * @memberof Sgkd004dSearchConditionComponent
   */
  changeAcceptbaseCompany(): void {
    this.conditionForm.get('acceptbaseSosiki').setValue(SgKdConstants.STR.EMPTY);
    if (this.conditionForm.get('acceptbaseCompany').value === SgKdConstants.STR.EMPTY) {
      this.conditionForm.get('acceptbaseSosiki').disable();
    } else {
      this.filteredRepbaseList(this.conditionForm.get('acceptbaseCompany').value);
      this.conditionForm.get('acceptbaseSosiki').enable();
    }
  }

  /**
   * 検索ボタン押下処理
   * 
   * @memberof Sgkd004dSearchConditionComponent 
   */
  onClickSearch(): void {

    this.clearMessageEvent.emit('');

    let company = this.conditionForm.get('acceptbaseCompany').value;
    let sosiki = this.conditionForm.get('acceptbaseSosiki').value;
    let from = '';
    if (this.conditionForm.get('aceptDateFrom').value) {
      from = this.timeApiService.convertDateToString(this.conditionForm.get('aceptDateFrom').value);
    }
    let to = '';
    if (this.conditionForm.get('aceptDateTo').value) {
      to = this.timeApiService.convertDateToString(this.conditionForm.get('aceptDateTo').value);
    }
    let srndocClscode = this.conditionForm.get('srndocClsfy').value;
    let srndocDeliveryStatuscode = this.conditionForm.get('srndocDeliverySts').value;

    // 申込書一覧取得
    this.usedSgkd004dSgkd016aService.select(company, sosiki, from, to, srndocClscode, srndocDeliveryStatuscode)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.resultList = response.responseDto.kohuriCrdsrndocIkkatuprtList;
        this.responseEmitter.emit(this.resultList);
      }, error => {
      });
  }

  /**
   * クリアボタン押下処理
   * 
   * @memberof Sgkd004dSearchConditionComponent 
   */
  onClickClear(): void {
    this.init();
  }

  /**
   * 戻るボタン押下処理
   * 
   * @memberof Sgkd004dSearchConditionComponent 
   */
  goToPrevious(): void {
    this.router.navigate([SgKdConstants.PATH.MANAGE_MENU]);
  }

  /**
   * クリアボタン活性制御
   * 
   * @returns 非活性の場合true/活性の場合false
   * @memberof Sgkd004dSearchConditionComponent 
   */
  disabledCleaerButton(): boolean {
    if (this.conditionForm.get('acceptbaseCompany')?.value !== SgKdConstants.STR.EMPTY ||
        this.conditionForm.get('srndocClsfy')?.value !== SgKdConstants.CODE.SRNDOC_CLSFY_CODE.USER_CODE.KOHURI ||
        this.conditionForm.get('aceptDateFrom')?.value !== SgKdConstants.STR.EMPTY ||
        this.conditionForm.get('aceptDateTo')?.value !== this.dateBusinessDate ||
        this.conditionForm.get('srndocDeliverySts')?.value !== SgKdConstants.CODE.SRNDOC_SEND_STS_CODE.USER_CODE.ACEPT) {
      return false;
    }
    return true;
  }

  /**
   * フォームの生成
   * 
   * @returns 本コンポーネントのForm情報
   * @memberof Sgkd004dSearchConditionComponent
   */
  private createForm(): UntypedFormGroup {
    let form = this.formBuilder.group({
      /** 受付拠点（会社） */
      acceptbaseCompany: new UntypedFormControl(
        { value: '', disabled: false }),
      /** 受付拠点（組織） */
      acceptbaseSosiki: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 申込書種別 */
      srndocClsfy: new UntypedFormControl(
        { value: '', disabled: false },
        [ Validators.required ]),
      /** 受付日(From) */
      aceptDateFrom: new UntypedFormControl(
        {value: '', disabled: false }),
      /** 受付日(To) */
      aceptDateTo: new UntypedFormControl(
        { value: '', disabled: false },
        [ Validators.required ]),
      /** 申込書送付ステータス */
      srndocDeliverySts: new UntypedFormControl(
        { value: '', disabled: false })
    });
    return form;
  }

  /**
   * コード値読込
   *
   * @memberof Sgkd004dSearchConditionComponent
   */
  private loadCodeList(): void {
    this.codeConversionMstService.getCodeConversionMst([
      // 会社コード
      SgKdConstants.CODE.COM_CODE.DISP_ITEM_ID,
      // 申込書種別コード
      SgKdConstants.CODE.SRNDOC_CLSFY_CODE.DISP_ITEM_ID,
      // 申込書送付ステータス
      SgKdConstants.CODE.SRNDOC_SEND_STS_CODE.DISP_ITEM_ID
    ]).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          this.companyCodeList = this.sortedCodeSelectBox(response.get(SgKdConstants.CODE.COM_CODE.DISP_ITEM_ID));
          this.srndocClsfyCodeList = this.sortedCodeSelectBox(response.get(SgKdConstants.CODE.SRNDOC_CLSFY_CODE.DISP_ITEM_ID));
          this.srndocDeliveryStatuscodeList = this.sortedCodeSelectBox(response.get(SgKdConstants.CODE.SRNDOC_SEND_STS_CODE.DISP_ITEM_ID));
          this.init();
          this.loadedCodeList = true;
        }
    )
  }

  /**
   * 初期値設定
   * 
   * @memberof Sgkd004dSearchConditionComponent
   */
  private init(): void {
    this.conditionForm.get('acceptbaseCompany').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('acceptbaseSosiki').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('acceptbaseSosiki').disable();
    this.conditionForm.get('srndocClsfy').setValue(SgKdConstants.CODE.SRNDOC_CLSFY_CODE.USER_CODE.KOHURI);
    this.conditionForm.get('aceptDateFrom').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('aceptDateTo').setValue(this.dateBusinessDate);
    this.conditionForm.get('srndocDeliverySts').setValue(SgKdConstants.CODE.SRNDOC_SEND_STS_CODE.USER_CODE.ACEPT);
  }

  /**
   * コードリストを項目並び順番でソートしたセレクトボックスを取得
   * @param array - コードリスト
   * @returns - 項目並び順番でソートされたコードリストのセレクトボックス
   *
   * @memberof Sgkd004dSearchConditionComponent
   */
  private sortedCodeSelectBox(array: Array<CodeConversionMstDto>): SelectBox[] {

    let returnArray: SelectBox[] = [];
    array
      .sort((x, y) => x.hyojiRowTurn.localeCompare(y.hyojiRowTurn))
      .forEach(x => returnArray.push({ value: x.userCode, viewValue: x.hyojiCont}));
    return returnArray;
  }

  private filteredRepbaseList(companyCode: string): void {
    this.repbaseList = [];
    let filteredList = []
    this.allRepbaseList.forEach((sosikiInfo) => {
      if (sosikiInfo.companyCode === companyCode) {
        filteredList.push({
          value: sosikiInfo.sosikiNo,
          viewValue: sosikiInfo.sosikiGeneration
        });
      }
    });
    this.repbaseList = filteredList;
  }
}
